export default "__VITE_ASSET__6fa095bf__"